import { Activity, Building2, FileText, Sparkles } from 'lucide-react';
import { AppLayout } from '@/components/shell/app-layout';
import type { NavItem } from '@/components/shell/navigation';
import { Badge } from '@/components/ui/badge';
import { PendingPoliciesBanner } from '@/features/platform/components/policies/pending-policies-banner';

const PLATFORM_NAV: NavItem[] = [
  { kind: 'link', label: 'Saúde', to: '/plataforma/saude', icon: Activity },
  { kind: 'link', label: 'Empresas', to: '/plataforma/empresas', icon: Building2 },
  {
    kind: 'group',
    label: 'Inteligência artificial',
    icon: Sparkles,
    children: [
      { label: 'Visão geral', to: '/plataforma/ia' },
      { label: 'Prompts', to: '/plataforma/ia/prompts' },
      { label: 'Funções e modelos', to: '/plataforma/ia/funcoes' },
      { label: 'Provedores', to: '/plataforma/ia/provedores' },
    ],
  },
  { kind: 'link', label: 'Políticas de tarifa', to: '/plataforma/politicas', icon: FileText },
];

/**
 * Moldura do painel da plataforma (ADR-027). O selo deixa claro, a todo momento, que se está
 * fora das empresas — é aqui que se cadastra, suspende e convida, nunca onde se opera.
 */
export function PlatformShell() {
  return (
    <AppLayout
      home="/plataforma"
      items={PLATFORM_NAV}
      context={
        <Badge variant="secondary" className="w-fit group-data-[collapsible=icon]:hidden">
          Painel da plataforma
        </Badge>
      }
      accountPath="/plataforma/conta"
      banner={<PendingPoliciesBanner />}
    />
  );
}
